<template>
  <div class="search-control" style="max-width:240px;">
    <input class="form-control" type="text" placeholder="Buscar" v-model="search" v-on:keyup.enter="$emit('doSearch', search)" />
    <button class="search__btn" @click="$emit('doSearch', search)">
      <i class="fas fa-search"></i>
    </button>
  </div>
</template>
<script>
export default {
  data() {
    return {
      search: '',
    };
  },
};
</script>
<style scoped>
.search-control {
  max-width: 240px;
}
</style>
